import SchedulingAvailabilityGridHeaderCell from "../SchedulingAvailabilityGridHeaderCell/SchedulingAvailabilityGridHeaderCell";
import { DAYS } from "@platform/features/timeslots/timeslots.constants";

export function SchedulingAvailabilityGridHeaderRow() {
  return (
    <div role="row" className="contents">
      {/* Spacer cell for the time column */}
      <SchedulingAvailabilityGridHeaderCell className="h-auto pb-1 text-center sticky left-0 bg-brand-50 z-30" />

      {/* Day names */}
      {DAYS.map((day, index) => (
        <SchedulingAvailabilityGridHeaderCell
          className="h-auto pb-1 pt-7 text-center"
          key={`day-${index}`}
        >
          {day}
        </SchedulingAvailabilityGridHeaderCell>
      ))}
    </div>
  );
}

export default SchedulingAvailabilityGridHeaderRow;
